import { Button as AntButton } from 'antd';
import type { ButtonProps } from 'antd';
import './style.scss';

export const Button = (props: ButtonProps) => {
  return <AntButton {...props} />;
};
